/* ── Studio Phalsa — Hero Carousel JS ───────────────────────── */
(function () {
  'use strict';

  var fan = document.getElementById('sp-hero-fan');
  if (!fan) return;

  var slides      = Array.from(fan.querySelectorAll('.sp-hero__slide'));
  var dotsWrap    = document.getElementById('sp-hero-dots');
  var totalSlides = slides.length;
  if (totalSlides < 2) return;

  var autoplay     = fan.dataset.autoplay !== 'false';
  var interval     = parseInt(fan.dataset.interval || '3000', 10);
  var heroSection  = document.getElementById('sp-hero') || fan;

  var timer = null;   // the one active setInterval — null when stopped

  /* ── Helpers ──────────────────────────────────────────────────── */
  function getPos(slide)      { return parseInt(slide.dataset.pos, 10); }
  function setPos(slide, pos) { slide.dataset.pos = String(pos); }
  function slideAtPos(pos)    { return slides.find(function (s) { return getPos(s) === pos; }); }

  /* ── Dots ─────────────────────────────────────────────────────── */
  function updateDots() {
    if (!dotsWrap) return;
    var activeIdx = slides.indexOf(slideAtPos(2));
    Array.from(dotsWrap.querySelectorAll('.sp-hero__dot')).forEach(function (dot, i) {
      dot.classList.toggle('is-active', i === activeIdx);
    });
  }

  /* ── Rotate (forward) ─────────────────────────────────────────── */
  /* Wrap-around jump done synchronously with offsetWidth flushes:
     transition:none + opacity:0 on the wrapping slide → flush →
     shift all data-pos → flush → re-enable. No rAF needed.         */
  function rotate() {
    var wrapping = slideAtPos(0);
    if (!wrapping) return;

    fan.classList.add('is-rotating');

    wrapping.style.transition = 'none';
    wrapping.style.opacity    = '0';
    void wrapping.offsetWidth;

    slides.forEach(function (s) {
      var p = getPos(s);
      setPos(s, p === 0 ? totalSlides - 1 : p - 1);
    });

    void fan.offsetWidth;

    wrapping.style.transition = '';
    wrapping.style.opacity    = '';
    fan.classList.remove('is-rotating');
    updateDots();
  }

  /* ── Rotate (back) ────────────────────────────────────────────── */
  function rotateBack() {
    var wrapping = slideAtPos(totalSlides - 1);
    if (!wrapping) return;

    fan.classList.add('is-rotating');

    wrapping.style.transition = 'none';
    wrapping.style.opacity    = '0';
    void wrapping.offsetWidth;

    slides.forEach(function (s) {
      var p = getPos(s);
      setPos(s, p === totalSlides - 1 ? 0 : p + 1);
    });

    void fan.offsetWidth;

    wrapping.style.transition = '';
    wrapping.style.opacity    = '';
    fan.classList.remove('is-rotating');
    updateDots();
  }

  /* ── Slider start / stop ──────────────────────────────────────── */
  function startSlider() {
    if (!autoplay || timer || document.hidden) return;
    timer = setInterval(rotate, interval);
  }

  function stopSlider() {
    clearInterval(timer);
    timer = null;
  }

  /* ── Viewport tracking ────────────────────────────────────────── */
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        startSlider();
      } else {
        stopSlider();
      }
    });
  }, { threshold: 0.1 });

  observer.observe(heroSection);

  /* ── Tab visibility ───────────────────────────────────────────── */
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) {
      stopSlider();
    } else {
      startSlider();
    }
  });

  /* ── Touch / swipe ────────────────────────────────────────────── */
  var touchStartX = 0;
  var touchStartY = 0;

  fan.addEventListener('touchstart', function (e) {
    touchStartX = e.changedTouches[0].clientX;
    touchStartY = e.changedTouches[0].clientY;
  }, { passive: true });

  fan.addEventListener('touchend', function (e) {
    var dx = e.changedTouches[0].clientX - touchStartX;
    var dy = e.changedTouches[0].clientY - touchStartY;
    if (Math.abs(dx) < 40 || Math.abs(dy) > Math.abs(dx)) return;
    if (dx < 0) { rotate(); } else { rotateBack(); }
    stopSlider();
    startSlider();
  }, { passive: true });

  /* ── Dot clicks ───────────────────────────────────────────────── */
  if (dotsWrap) {
    dotsWrap.querySelectorAll('.sp-hero__dot').forEach(function (dot, targetIdx) {
      dot.addEventListener('click', function () {
        stopSlider();
        var currentCenterIdx = slides.indexOf(slideAtPos(2));
        var steps = (targetIdx - currentCenterIdx + totalSlides) % totalSlides;
        if (steps > totalSlides / 2) steps = steps - totalSlides;
        if (steps === 0) { startSlider(); return; }

        var fn  = steps > 0 ? rotate : rotateBack;
        var abs = Math.abs(steps);
        var i   = 0;

        function step() {
          fn();
          i++;
          if (i < abs) { setTimeout(step, 200); } else { startSlider(); }
        }
        step();
      });
    });
  }

  /* ── Prev / next arrows ───────────────────────────────────────── */
  var prevBtn = document.getElementById('sp-hero-prev');
  var nextBtn = document.getElementById('sp-hero-next');

  if (prevBtn) {
    prevBtn.addEventListener('click', function () {
      rotateBack();
      stopSlider();
      startSlider();
    });
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', function () {
      rotate();
      stopSlider();
      startSlider();
    });
  }

  /* ── Keyboard ─────────────────────────────────────────────────── */
  fan.setAttribute('tabindex', '0');
  fan.addEventListener('keydown', function (e) {
    if (e.key === 'ArrowLeft')  { rotateBack(); stopSlider(); startSlider(); }
    if (e.key === 'ArrowRight') { rotate();     stopSlider(); startSlider(); }
  });

  /* ── Init ─────────────────────────────────────────────────────── */
  updateDots();

  /* Entrance animation fires exactly once — class is removed after the
     longest stagger (0.35 s delay + 0.8 s duration) so data-pos changes
     during rotation never re-trigger the keyframe.                    */
  fan.classList.add('sp-hero__fan--entering');
  setTimeout(function () {
    fan.classList.remove('sp-hero__fan--entering');
  }, 1200);

  startSlider();

})();
